export interface Movie {
  id: string;
  title: string;
  category: string;
  year: number;
  rating: number;
  image: string;
  description: string;
  director: string;
  actors: string[];
  duration: string;
  releaseDate: string;
  language: string;
  region: string;
  tags: string[];
  content: string;
}

export const movieCategories = [
  { id: "all", name: "全部", icon: "ri-movie-line" },
  { id: "action", name: "动作", icon: "ri-fire-line" },
  { id: "comedy", name: "喜剧", icon: "ri-emotion-happy-line" },
  { id: "scifi", name: "科幻", icon: "ri-rocket-line" },
  { id: "romance", name: "爱情", icon: "ri-heart-line" },
  { id: "suspense", name: "悬疑", icon: "ri-ghost-line" },
  { id: "animation", name: "动画", icon: "ri-palette-line" },
  { id: "war", name: "战争", icon: "ri-shield-line" },
  { id: "documentary", name: "纪录片", icon: "ri-camera-line" },
];

export const movies: Movie[] = [
  {
    id: "movie-1",
    title: "星际穿越",
    category: "scifi",
    year: 2014,
    rating: 9.4,
    image: "https://readdy.ai/api/search-image?query=Interstellar%20movie%20poster%20style%2C%20deep%20space%20with%20wormhole%20and%20astronaut%2C%20cinematic%20lighting%2C%20dark%20cosmic%20background%20with%20stars%2C%20dramatic%20atmosphere%2C%20film%20poster%20aesthetic%2C%20warm%20golden%20accents%20on%20dark%20backdrop&width=800&height=1200&seq=movie-scifi-01&orientation=portrait",
    description: "一组探险者穿越虫洞，为人类寻找新家园的壮丽太空之旅，诺兰导演科幻巨制。",
    director: "克里斯托弗·诺兰",
    actors: ["马修·麦康纳", "安妮·海瑟薇", "杰西卡·查斯坦"],
    duration: "169分钟",
    releaseDate: "2014-11-12",
    language: "英语",
    region: "美国",
    tags: ["太空", "时间", "亲情", "硬科幻"],
    content: "在不远的未来，地球气候恶化，水资源枯竭，人类面临灭绝的威胁。前NASA宇航员库珀在女儿墨菲的书房里发现了神秘的重力场现象，由此被引向一个秘密的NASA基地。在那里，布兰德教授告诉他，土星附近出现了一个虫洞，可能是外星智慧生物放置在那里，为人类提供了一条通往其他星系的通道。库珀告别了家人，与布兰德博士的女儿艾米莉亚以及其他两位科学家一起，乘坐飞船穿越虫洞，前往三个潜在的宜居星球进行探索。在一系列惊心动魄的冒险中，库珀最终进入了五维空间，通过引力波向过去的女儿传递了关键信息，拯救了人类文明。",
  },
  {
    id: "movie-2",
    title: "功夫",
    category: "action",
    year: 2004,
    rating: 8.8,
    image: "https://readdy.ai/api/search-image?query=Kung%20Fu%20Hustle%20movie%20poster%20style%2C%20martial%20arts%20themed%2C%20vibrant%20red%20and%20gold%20tones%2C%20Chinese%20martial%20arts%20film%20aesthetic%2C%20dramatic%20action%20pose%2C%20warm%20cinematic%20lighting%2C%20vintage%20Chinese%20movie%20poster&width=800&height=1200&seq=movie-action-01&orientation=portrait",
    description: "周星驰自导自演的经典功夫喜剧，讲述一个小混混在猪笼城寨中意外卷入江湖纷争的故事。",
    director: "周星驰",
    actors: ["周星驰", "黄圣依", "元秋", "元华"],
    duration: "99分钟",
    releaseDate: "2004-12-23",
    language: "粤语/国语",
    region: "中国香港",
    tags: ["喜剧", "功夫", "经典", "周星驰"],
    content: "1940年代的上海，小混混阿星一心想加入势力庞大的斧头帮。他冒充斧头帮成员来到猪笼城寨敲诈勒索，却不料这个看似贫民窟的地方卧虎藏龙，居住着多位隐退的武林高手。斧头帮老大琛哥得知后大怒，率众前来报复，却屡遭挫败。一场惊心动魄的江湖大战就此展开。阿星在经历了一系列奇遇后，发现自己竟然拥有万中无一的武学奇才潜质，最终以如来神掌击败了终极反派火云邪神，从一个街头混混蜕变成了真正的功夫大师。",
  },
  {
    id: "movie-3",
    title: "夏洛特烦恼",
    category: "comedy",
    year: 2015,
    rating: 8.5,
    image: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20poster%20style%2C%20nostalgic%20school%20scene%2C%20warm%20vibrant%20colors%2C%20retro%20Chinese%20high%20school%20setting%2C%20fun%20and%20lively%20atmosphere%2C%20cinematic%20comedy%20poster%2C%20bright%20natural%20lighting&width=800&height=1200&seq=movie-comedy-01&orientation=portrait",
    description: "沈腾、马丽主演的爆笑喜剧，中年失意的夏洛穿越回高中时代，重新书写人生的荒诞故事。",
    director: "闫非 / 彭大魔",
    actors: ["沈腾", "马丽", "尹正", "艾伦"],
    duration: "104分钟",
    releaseDate: "2015-09-30",
    language: "国语",
    region: "中国大陆",
    tags: ["喜剧", "穿越", "青春", "搞笑"],
    content: "中年失意的夏洛在昔日校花秋雅的婚礼上醉酒大闹，被妻子马冬梅追打。在卫生间里，夏洛意外穿越回到了1997年的高中时代。他利用对未来的预知，抄袭流行歌曲一举成名，成为家喻户晓的音乐巨星，还如愿以偿地追到了女神秋雅。但当他拥有了曾经梦想的一切后，却发现自己内心深处最想念的，是那个曾经为他暖胃、为他打架、真心爱他的马冬梅。最终夏洛幡然醒悟，明白了平凡生活中的真情才是最珍贵的。",
  },
  {
    id: "movie-4",
    title: "流浪地球",
    category: "scifi",
    year: 2019,
    rating: 9.2,
    image: "https://readdy.ai/api/search-image?query=The%20Wandering%20Earth%20movie%20poster%20style%2C%20frozen%20earth%20with%20massive%20planet%20engines%2C%20epic%20sci-fi%20scale%2C%20ice%20and%20snow%20covering%20city%2C%20dramatic%20cinematic%20lighting%2C%20Chinese%20sci-fi%20blockbuster%20aesthetic%2C%20cool%20blue%20and%20orange%20contrast&width=800&height=1200&seq=movie-scifi-02&orientation=portrait",
    description: "中国科幻电影里程碑之作，太阳即将毁灭，人类在地球表面建造巨型推进器，开启长达2500年的流浪之旅。",
    director: "郭帆",
    actors: ["吴京", "屈楚萧", "李光洁", "吴孟达"],
    duration: "125分钟",
    releaseDate: "2019-02-05",
    language: "国语",
    region: "中国大陆",
    tags: ["科幻", "灾难", "刘慈欣", "国产"],
    content: "在不远的将来，太阳急速衰老膨胀，即将吞没整个太阳系。为了生存，人类联合政府决定启动「流浪地球计划」——在地球表面建造上万座行星发动机，推动地球离开太阳系，前往4.2光年外的比邻星。整个计划将耗时2500年，跨越100代人的时间。在地球飞越木星时，受到木星引力的影响，行星发动机大规模故障。航天员刘培强与国际空间站的同伴们在地球上面临生死存亡的关键时刻，一群年轻人挺身而出，展开了争分夺秒的生死救援。",
  },
  {
    id: "movie-5",
    title: "你的名字",
    category: "animation",
    year: 2016,
    rating: 9.0,
    image: "https://readdy.ai/api/search-image?query=Your%20Name%20anime%20movie%20poster%20style%2C%20beautiful%20sky%20with%20comet%2C%20two%20teenagers%20reaching%20out%2C%20Japanese%20anime%20aesthetic%2C%20soft%20dreamy%20colors%2C%20warm%20sunset%20gradient%2C%20romantic%20atmosphere%2C%20Makoto%20Shinkai%20style&width=800&height=1200&seq=movie-anime-01&orientation=portrait",
    description: "新海诚执导的唯美动画电影，两个素未谋面的少年少女，在梦中交换身体，开启了一段跨越时空的奇幻爱恋。",
    director: "新海诚",
    actors: ["神木隆之介", "上白石萌音"],
    duration: "106分钟",
    releaseDate: "2016-08-26",
    language: "日语",
    region: "日本",
    tags: ["动画", "爱情", "奇幻", "新海诚"],
    content: "生活在乡下的女高中生三叶，对枯燥的乡村生活感到厌倦，她许愿「来世让我成为东京的帅哥」。奇妙的是，她真的和东京的高中生瀧交换了身体。两人开始通过手机的备忘录互相沟通，逐渐了解对方的生活。然而某一天，这种交换突然停止了。瀧决定去寻找三叶，却发现了一个令人震惊的真相——三叶所在的小镇糸守町在三年前已经被一颗陨石摧毁。瀧通过三叶留下的口嚼酒穿越时空，试图在陨石坠落之前拯救小镇和三叶。",
  },
  {
    id: "movie-6",
    title: "泰坦尼克号",
    category: "romance",
    year: 1997,
    rating: 9.5,
    image: "https://readdy.ai/api/search-image?query=Titanic%20movie%20poster%20style%2C%20romantic%20couple%20on%20ship%20bow%2C%20golden%20sunset%20over%20ocean%2C%20classic%20film%20poster%20aesthetic%2C%20dramatic%20romantic%20atmosphere%2C%20warm%20golden%20and%20deep%20blue%20contrast%2C%20epic%20romance&width=800&height=1200&seq=movie-romance-01&orientation=portrait",
    description: "詹姆斯·卡梅隆执导的史诗级爱情灾难片，穷画家杰克与贵族少女露丝在泰坦尼克号上相遇相爱的感人故事。",
    director: "詹姆斯·卡梅隆",
    actors: ["莱昂纳多·迪卡普里奥", "凯特·温斯莱特"],
    duration: "194分钟",
    releaseDate: "1997-12-19",
    language: "英语",
    region: "美国",
    tags: ["爱情", "灾难", "经典", "史诗"],
    content: "1912年，泰坦尼克号从英国南安普顿出发，驶向美国纽约。在这艘号称「永不沉没」的豪华游轮上，穷困的画家杰克在一次意外中救了厌倦上流社会生活的贵族少女露丝。两个来自不同世界的人坠入了爱河。然而就在他们沉浸在甜蜜之中时，泰坦尼克号撞上了冰山，这艘巨轮开始缓缓沉入冰冷的大西洋。在生死关头，杰克把生存的机会留给了露丝，自己则在冰冷的海水中永远地闭上了眼睛。84年后，年迈的露丝依然珍藏着那段刻骨铭心的记忆。",
  },
  {
    id: "movie-7",
    title: "盗梦空间",
    category: "suspense",
    year: 2010,
    rating: 9.3,
    image: "https://readdy.ai/api/search-image?query=Inception%20movie%20poster%20style%2C%20city%20folding%20inward%2C%20surreal%20dream%20landscape%2C%20mind-bending%20visuals%2C%20dark%20mysterious%20atmosphere%2C%20cinematic%20thriller%20aesthetic%2C%20deep%20shadows%20with%20warm%20highlights&width=800&height=1200&seq=movie-suspense-01&orientation=portrait",
    description: "诺兰又一神作，专业窃贼通过潜入他人梦境窃取秘密，一场在多层梦境中展开的惊天行动。",
    director: "克里斯托弗·诺兰",
    actors: ["莱昂纳多·迪卡普里奥", "约瑟夫·高登-莱维特", "艾伦·佩吉"],
    duration: "148分钟",
    releaseDate: "2010-07-16",
    language: "英语",
    region: "美国",
    tags: ["悬疑", "科幻", "梦境", "烧脑"],
    content: "道姆·柯布是一位经验老道的窃贼，他擅长在人们精神最为脆弱的梦境中盗取潜意识中的秘密。这使得他成为商业间谍领域炙手可热的人物，却也让他失去了所爱之人，沦为国际逃犯。如今柯布获得了赎罪的机会——他需要完成一个看似不可能的任务：不是窃取想法，而是在目标对象的潜意识中植入一个想法。如果成功，这将彻底改变目标的人生轨迹。柯布组建了一支精英团队，层层深入地潜入目标的梦境之中，但危险也在逼近……",
  },
  {
    id: "movie-8",
    title: "红海行动",
    category: "war",
    year: 2018,
    rating: 8.9,
    image: "https://readdy.ai/api/search-image?query=Operation%20Red%20Sea%20movie%20poster%20style%2C%20military%20special%20forces%20in%20action%2C%20desert%20warfare%20scene%2C%20intense%20combat%20cinematography%2C%20Chinese%20military%20film%20aesthetic%2C%20dramatic%20dust%20and%20explosions%2C%20warm%20desert%20tones&width=800&height=1200&seq=movie-war-01&orientation=portrait",
    description: "根据真实事件改编，中国海军蛟龙突击队8名队员在异国他乡执行撤侨任务，展开惊心动魄的营救行动。",
    director: "林超贤",
    actors: ["张译", "黄景瑜", "海清", "杜江"],
    duration: "138分钟",
    releaseDate: "2018-02-16",
    language: "国语",
    region: "中国大陆",
    tags: ["战争", "军事", "真实事件", "热血"],
    content: "中东某国发生内战，我国侨民面临生命危险。中国海军蛟龙突击队8名队员奉命前往执行撤侨任务。任务过程中，突击队遭遇重重险阻，面临着极端恶劣的环境和穷凶极恶的敌人。在一次又一次的激烈交火中，突击队员们凭借着过硬的军事素质和钢铁般的意志，克服了弹药不足、通讯中断等困难，在弹尽粮绝的边缘完成了保护侨民安全撤离的艰巨任务，展现了中国军人的血性与担当。",
  },
  {
    id: "movie-9",
    title: "我不是药神",
    category: "comedy",
    year: 2018,
    rating: 9.6,
    image: "https://readdy.ai/api/search-image?query=Dying%20to%20Survive%20Chinese%20film%20poster%20style%2C%20ordinary%20man%20in%20urban%20setting%2C%20warm%20realistic%20tones%2C%20humanistic%20drama%20aesthetic%2C%20Chinese%20street%20scene%2C%20emotional%20depth%2C%20cinematic%20portrait%20lighting&width=800&height=1200&seq=movie-drama-01&orientation=portrait",
    description: "徐峥主演的现实主义力作，一个普通中年男人从印度代购白血病仿制药，在法与情的夹缝中上演的催泪故事。",
    director: "文牧野",
    actors: ["徐峥", "王传君", "周一围", "谭卓"],
    duration: "117分钟",
    releaseDate: "2018-07-05",
    language: "国语",
    region: "中国大陆",
    tags: ["剧情", "现实", "感人", "社会"],
    content: "程勇是一个经营保健品店的中年男人，生活窘迫。一个偶然的机会，他发现了从印度代购白血病仿制药的商机。这种仿制药的疗效与正版药相当，但价格只有正版药的几十分之一。程勇从最初的逐利心态，到逐渐被病友们的信任和依赖所打动，他开始冒着法律风险为更多的白血病患者提供廉价药物。当警察开始追查走私药品时，程勇面临着艰难的选择——是保全自己，还是继续帮助那些素不相识却命悬一线的病友们。",
  },
  {
    id: "movie-10",
    title: "千与千寻",
    category: "animation",
    year: 2001,
    rating: 9.4,
    image: "https://readdy.ai/api/search-image?query=Spirited%20Away%20anime%20movie%20poster%20style%2C%20girl%20in%20magical%20spirit%20world%2C%20Japanese%20bathhouse%20scene%2C%20Hayao%20Miyazaki%20aesthetic%2C%20warm%20vibrant%20colors%2C%20fantasy%20atmosphere%2C%20whimsical%20and%20enchanting&width=800&height=1200&seq=movie-anime-02&orientation=portrait",
    description: "宫崎骏巅峰之作，少女千寻误入神灵世界，在汤屋中经历了一段奇幻冒险，荣获奥斯卡最佳动画长片。",
    director: "宫崎骏",
    actors: ["柊瑠美", "入野自由"],
    duration: "125分钟",
    releaseDate: "2001-07-20",
    language: "日语",
    region: "日本",
    tags: ["动画", "奇幻", "成长", "宫崎骏"],
    content: "10岁的少女千寻和父母在搬家途中误入了一个神秘的隧道，来到了一个奇幻的神灵世界。在这个世界中，千寻的父母因为贪吃而变成了猪。为了救回父母并回到原来的世界，千寻在神秘少年白龙的帮助下，来到汤婆婆经营的汤屋工作。在这个充满妖怪和神灵的奇幻世界里，千寻从一个胆小的女孩逐渐成长为一个勇敢、坚强的少女。她用自己的善良和勇气帮助了河神、无脸男等伙伴，最终凭借自己的努力赢得了回家的机会。",
  },
  {
    id: "movie-11",
    title: "速度与激情7",
    category: "action",
    year: 2015,
    rating: 8.6,
    image: "https://readdy.ai/api/search-image?query=Fast%20and%20Furious%207%20movie%20poster%20style%2C%20fast%20cars%20in%20action%2C%20urban%20racing%20scene%2C%20explosive%20action%20cinematography%2C%20warm%20orange%20and%20dark%20tones%2C%20high%20octane%20energy%2C%20muscle%20cars&width=800&height=1200&seq=movie-action-02&orientation=portrait",
    description: "飞车家族再次集结，多米尼克与伙伴们面对前所未有的强敌，在全球各地展开极速追逐。",
    director: "温子仁",
    actors: ["范·迪塞尔", "保罗·沃克", "杰森·斯坦森"],
    duration: "137分钟",
    releaseDate: "2015-04-03",
    language: "英语",
    region: "美国",
    tags: ["动作", "赛车", "冒险", "系列"],
    content: "多米尼克和他的团队在经历了伦敦的激战后回到美国，过上了平静的生活。然而，一名冷血的杀手——戴克·肖出现了，他是被多米尼克团队击败的欧文·肖的哥哥，前来为弟弟复仇。戴克·肖杀死了韩，并威胁到了多米尼克团队每一个成员的安全。为了对抗这个前所未有的强大敌人，多米尼克不得不与一个神秘的政府特工合作，在全球各地展开了一场惊心动魄的追逐战。本片也是保罗·沃克的遗作，片尾的告别场景令人泪目。",
  },
  {
    id: "movie-12",
    title: "地球脉动",
    category: "documentary",
    year: 2006,
    rating: 9.7,
    image: "https://readdy.ai/api/search-image?query=Planet%20Earth%20nature%20documentary%20poster%20style%2C%20stunning%20wildlife%20photography%2C%20diverse%20ecosystems%2C%20polar%20bear%20in%20arctic%20landscape%2C%20warm%20natural%20tones%2C%20epic%20scale%2C%20BBC%20documentary%20aesthetic&width=800&height=1200&seq=movie-doc-01&orientation=portrait",
    description: "BBC出品的史诗级自然纪录片，历时五年拍摄，横跨七大洲，呈现地球上最壮观的自然奇观与野生动植物。",
    director: "艾雷斯泰·法瑟吉尔",
    actors: ["大卫·爱登堡"],
    duration: "550分钟（全11集）",
    releaseDate: "2006-02-27",
    language: "英语",
    region: "英国",
    tags: ["纪录片", "自然", "BBC", "高清"],
    content: "《地球脉动》是BBC制作的史诗级自然纪录片系列，历时五年拍摄，足迹遍布全球七大洲的62个国家和地区。从南极冰原到撒哈拉沙漠，从深海热泉到喜马拉雅山脉，摄制组运用当时最先进的拍摄技术，捕捉到了无数令人叹为观止的自然奇观和野生动物的珍贵画面。每一集聚焦一个特定的生态环境，从极地到沙漠，从深海到丛林，深入展现了地球上生命的多样性和大自然的壮美，以及生物们为生存而展现出的惊人智慧与顽强生命力。",
  },
];

export const hotRankings = [
  { rank: 1, movieId: "movie-9", hotScore: 9856 },
  { rank: 2, movieId: "movie-4", hotScore: 9234 },
  { rank: 3, movieId: "movie-1", hotScore: 8901 },
  { rank: 4, movieId: "movie-7", hotScore: 8456 },
  { rank: 5, movieId: "movie-6", hotScore: 8012 },
  { rank: 6, movieId: "movie-10", hotScore: 7654 },
  { rank: 7, movieId: "movie-5", hotScore: 7234 },
  { rank: 8, movieId: "movie-2", hotScore: 6890 },
  { rank: 9, movieId: "movie-8", hotScore: 6456 },
  { rank: 10, movieId: "movie-3", hotScore: 6012 },
];

export const latestMovies = ["movie-4", "movie-8", "movie-9", "movie-11", "movie-5", "movie-7"];

export const heroMovies = ["movie-1", "movie-4", "movie-6"];

export const testimonials = [
  {
    name: "电影爱好者小王",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20avatar%2C%20casual%20style%2C%20warm%20friendly%20expression%2C%20clean%20minimal%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-01&orientation=squarish",
    content: "萝卜影视的资源真的太全了！我想看的经典老片和新上映的大片都能找到，画质清晰流畅，观影体验一级棒。强烈推荐给所有影迷朋友！",
    rating: 5,
  },
  {
    name: "追剧达人小李",
    avatar: "https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20avatar%2C%20modern%20casual%20style%2C%20warm%20smile%2C%20clean%20minimal%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-02&orientation=squarish",
    content: "每天下班后的最大享受就是打开萝卜影视找一部好电影看。分类清晰，推荐精准，几乎没有卡顿，是我用过的观影体验最好的平台！",
    rating: 5,
  },
  {
    name: "资深影评人老张",
    avatar: "https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20avatar%2C%20intellectual%20style%2C%20warm%20confident%20expression%2C%20clean%20minimal%20background%2C%20professional%20headshot&width=100&height=100&seq=avatar-03&orientation=squarish",
    content: "作为一个看了二十多年电影的老影迷，萝卜影视的片库深度让我惊喜。从影史经典到小众佳作，更新速度也很快，五星好评！",
    rating: 5,
  },
];